import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import { ManageService } from '../services/manage.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';


class PartnerProgramDetail {
    out_result_status: string;
    out_description: string;
    out_programcode: string;
    out_accountcode: string;
    out_message: string;
    out_value: string;
    out_vendor: string;
    isActive: boolean;
}


export interface VendorDictionary {
    [key: string]: string;
}

class RenewalsCategory {
    startDate: string;
    endDate: string;
    month: string;
    isActive: boolean
}

@Component({
    selector: 'app-manage-renewals-portal',
    templateUrl: './manage-renewals-portal.component.html',
    styleUrls: ['./manage-renewals-portal.component.css']
})

export class ManageRenewalsPortal implements OnInit, OnDestroy {

    @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb

    renewalsCategories = {
        currentRenewals: 'currentRenewals',
        upcomingRenewals: 'upcomingRenewals',
        expiredRenewals: 'expiredRenewals'
    }
    months = {
        'JAN': '01',
        'FEB': '02',
        'MAR': '03',
        'APR': '04',
        'MAY': '05',
        'JUN': '06',
        'JUL': '07',
        'AUG': '08',
        'SEP': '09',
        'OCT': '10',
        'NOV': '11',
        'DEC': '12'
    };
    statusList: string[] = [
        'LOST',
        'OPEN',
        'OPTOUT',
        'WAIT',
        'WON'
    ]
    selectedRenewals: RenewalsCategory = new RenewalsCategory();
    selectedPartnerProgram: PartnerProgramDetail = new PartnerProgramDetail();
    currentRenewals: RenewalsCategory;
    upcomingRenewals: RenewalsCategory[] = [];
    expiredRenewals: RenewalsCategory[] = [];
    loadContent: boolean;
    //activeRenewals: string;
    activedRenewalIndex: number;

    searchRenewals: string;
    renewalsTitle: string = '';


    //vendor renewals
    partnerProgramDetail: PartnerProgramDetail;

    vendorDic: VendorDictionary = {};
    isMiniBlade = false;
    isVendorRenwals = false;
    // unsubscribe
    ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private manageService: ManageService,
        private commonService: CommonService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        //initialize renewal date
        this.commonService.emitUpdateSideBarActiveItem('renewals');
        this.initialRenewals();
    }

    navigateTo(url: string) {
        this.router.navigate([url]);
    }

    ngOnInit() {
        this.manageService.GetPartnerProgramDetails().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: PartnerProgramDetail[]) => {
            this.partnerProgramDetail = res.filter(x => x.out_vendor == 'AUTODESK')[0];
            const urlCompArr = this.router.url.split("/");
            const out_vendor = urlCompArr[4];
            const out_value = urlCompArr[5];
            if(this.partnerProgramDetail && this.partnerProgramDetail.out_vendor == out_vendor && this.partnerProgramDetail.out_value == out_value) {
                this.selectedPartnerProgram = this.partnerProgramDetail;
            }
        },(error: any) => {
            console.info(error);
        });
        
        this.route.paramMap.pipe(tap((param) => { 
            let lastPara = this.router.url.split("/",4).pop();
            let start = "", end = "";
            [start,end] = lastPara.split("_");
            this.selectedRenewals.startDate = start;
            this.selectedRenewals.endDate = end;
            setTimeout(()=>{
                this.manageService.renewalsTitle.emit(this.findRenewalTitle(start,end));
            },100)
        })).pipe(takeUntil(this.ngUnsubscribe)).subscribe();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
            this.loadContent = true;
            const urlCompArr = this.router.url.split("/");
            if (urlCompArr.length==4 && urlCompArr.indexOf('month') > -1) {
                $('#levelOne').animate({ scrollLeft: 0 }, 400);
            }
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd),takeUntil(this.ngUnsubscribe)).subscribe(res => {
            this.breadcrumbRef.ngAfterViewInit();
        });
    }

    initialRenewals(): void {

        const options: any = { year: 'numeric', month: 'long' };
        //let date = new Date(2020, 6, 1);
        let date = new Date();
        let currentMoth = date.getMonth();
        date.setDate(1);
        date.setMonth(currentMoth - 4);

        for (let i = 1; i <= 7; i++) {

            let rc = new RenewalsCategory();

            if (i <= 3) {

                date.setDate(1);
                date.setMonth(date.getMonth() + 1)
                //console.log(`fistday of month`, date.toLocaleDateString('en-AU'));
                rc.startDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                date.setMonth(date.getMonth() + 1)
                date.setDate(0)
                //console.log(`lastday of month`, date.toLocaleDateString('en-AU'));
                rc.endDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                //month year
                rc.month = date.toLocaleDateString('en-AU', options);

                this.expiredRenewals.push(rc);

            } else if (i == 4) {

                date.setDate(1);
                date.setMonth(date.getMonth() + 1)
                //console.log(`fistday of month`, date.toLocaleDateString('en-AU'));
                rc.startDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                date.setMonth(date.getMonth() + 1)
                date.setDate(0)
                //console.log(`lastday of month`, date.toLocaleDateString('en-AU'));
                rc.endDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                //month year
                rc.month = date.toLocaleDateString('en-AU', options);

                this.currentRenewals = rc;

            } else {
                date.setDate(1);
                date.setMonth(date.getMonth() + 1)
                //console.log(`fistday of month`, date.toLocaleDateString('en-AU'));
                rc.startDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                date.setMonth(date.getMonth() + 1)
                date.setDate(0)
                //console.log(`lastday of month`, date.toLocaleDateString('en-AU'));
                rc.endDate = this.replaceAll(date.toLocaleDateString('en-AU'), '/', '-');

                //month year
                rc.month = date.toLocaleDateString('en-AU', options);

                this.upcomingRenewals.push(rc);
            }

        }

        const urlCompArr = this.router.url.split("/",4);
        if(urlCompArr.length == 2) {
            this.router.navigate([`manageRenewalsNew/month/${this.currentRenewals.startDate}_${this.currentRenewals.endDate}`]);
        } 
    }

    findRenewalTitle(start: string,end: string): string {
        if(this.currentRenewals.startDate == start && this.currentRenewals.endDate == end) {
            return this.currentRenewals.month;
        } else {
            var expArr = [...this.expiredRenewals,...this.upcomingRenewals].filter(x=> x.startDate == start && x.endDate == end);
            return expArr.length > 0 ? expArr[0].month : "";
        }
    }

    getVendorRenwals(program: PartnerProgramDetail) {
        this.selectedRenewals = new RenewalsCategory();
        this.selectedPartnerProgram = program;
        this.manageService.monitorVendorChange(program.out_vendor);
        this.manageService.monitorValueChange(program.out_value);
        this.router.navigate(['./renewalsEndUser/upComing/' + program.out_vendor + '/' + program.out_value], { relativeTo: this.route });
    }

    getRenewals(renewals: RenewalsCategory, type: string, index: number = 0) {
        this.selectedPartnerProgram = new PartnerProgramDetail();
        this.selectedRenewals.startDate = renewals.startDate;
        this.selectedRenewals.endDate = renewals.endDate;
        this.manageService.renewalsTitle.emit(renewals.month);
        this.router.navigate([`manageRenewalsNew/month/${renewals.startDate}_${renewals.endDate}`]);
    }

    replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    ngOnDestroy() {
        this.commonService.emitUpdateSideBarActiveItem('');
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
